<template>
  <div class>
    <div class="markdown newlist">
      <ul>
        <li
          class="new dis_flex"
          v-for="(item, index) in dataList"
          :key="index"
          @click="toDetail(typeid,item.id)"
        >
          <!-- <router-link :to="{name:'NewsDetail',params:{type:typeid,id:item.id}}" class="dis_flex"> -->
          <div class="img">
            <img
              :src="item.article_img+'?x-oss-process=image/resize,m_fill,h_150,w_280'"
              :alt="item.title"
              :title="item.title"
            />
          </div>
          <div class="info">
            <div class="title ellipsis">
              {{item.title}}
              <span class="time">{{item.created_time}}</span>
            </div>
            <div class="intro ellipsis3" v-html="item.introduce"></div>
          </div>
          <!-- </router-link> -->
        </li>
      </ul>
    </div>
    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      layout="total, prev, pager, next, jumper"
      :hide-on-single-page="total<listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>

import Pagination from '@/components/assembly/pagination'
export default {
  data () {
    return {
      dataList: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 6
      },
      typeid: this.$route.meta.typeid
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        // console.log(this.$route.meta)
        this.getList(this.$route.meta.typeid)
        this.getSeo()
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted () {
    this.getList(this.$route.meta.typeid)
    this.getSeo()
  },
  methods: {
    getList (typeid) {
      this.$https.fetchPost('/Article/article_list', {
        classifyid: this.$route.meta.typeid,
        page: this.listQuery.page,
        limit: this.listQuery.limit
      }).then((res) => {
        // console.log(res.data)
        this.dataList = res.data.data
        this.total = res.data.count
      }).catch(err => {
        console.log(err)
      })
    },
    getSeo () {
    },
    toDetail (type, id) {
      // console.log(type, id)
      if (type === 18) {
        this.$router.push({ name: 'detail', params: { noticeid: id } })
      } else {
        this.$router.push({ name: 'NewsDetail', params: { type: type, id: id } })
      }
    }
  },
  components: {
    Pagination
  }

}
</script>
<style lang="less">
.newlist {
  .new {
    padding: 25px 0;
    border-bottom: 1px solid #eeeeee;
    .img {
      width: 280px;
      height: 150px;
      border-radius: 5px;
      background-color: #eeeeee;
      margin-right: 28px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .info {
      flex: 1;
      .title {
        font-family: MicrosoftYaHei-Bold;
        font-size: 18px;
        font-weight: Bold;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 1px;
        color: #535353;
        padding-right: 20%;
        position: relative;
        .time {
          position: absolute;
          right: 0;
          top: 0;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 36px;
          letter-spacing: 0px;
          color: #999999;
        }
      }
      .intro {
        margin-top: 20px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 25px;
        letter-spacing: 0px;
        color: #535353;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assembly/newstemplate.vue